export const API_URL = process.env.API_URL;

export const SURVEY_EMBED_URL = process.env.SURVEY_MONKEY_EMBED_URL;
export const SOCIAL_CHANNELS = [
  {
    name: "facebook",
    url: "http://www.facebook.com/playbleedingedge"
  },
  {
    name: "instagram",
    url: "http://www.instagram.com/playbleedingedge"
  },
  {
    name: "twitter",
    url: "http://www.twitter.com/bleedingedgent"
  },
  {
    name: "youtube",
    url: "http://www.youtube.com/officialninjatheory"
  },
  {
    name: "discord",
    url: "https://discord.gg/95BS6eb"
  }
];
export const COOKIE_BANNER_URL = process.env.COOKIE_BANNER_URL;



// WEBPACK FOOTER //
// ./src/constants/consts.js